import { useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  WASTE_FORM_INPUT_CLASS,
  WASTE_FORM_LABEL_CLASS,
  WASTE_FORM_REQUIRED,
} from "./wasteFlowFormUi";

const toInputDateValue = (isoDate) => {
  if (!isoDate) return "";
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().split("T")[0];
};

const formatDisplayDate = (isoDate, language) => {
  if (!isoDate) return "";
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(language, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const WasteFlowDateField = ({
  id,
  label,
  value,
  onChange,
  required = false,
}) => {
  const { i18n, t } = useTranslation();
  const dateInputRef = useRef(null);
  const displayValue = formatDisplayDate(value, i18n.language);
  const hasValue = Boolean(displayValue);

  const openPicker = () => {
    const input = dateInputRef.current;
    if (!input) return;
    if (typeof input.showPicker === "function") {
      input.showPicker();
      return;
    }
    input.click();
  };

  const handleClear = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onChange("");
  };

  return (
    <div className="waste-flow-form-field">
      <label className={WASTE_FORM_LABEL_CLASS} htmlFor={id}>
        {label} {required ? WASTE_FORM_REQUIRED : null}
      </label>
      <div className="waste-flow-date-field">
        <button
          type="button"
          className={`waste-flow-date-field__display ${WASTE_FORM_INPUT_CLASS}${hasValue ? " waste-flow-date-field__display--filled" : ""}`}
          onClick={openPicker}
          aria-labelledby={id}
        >
          <span
            className={
              hasValue
                ? "waste-flow-date-field__value"
                : "waste-flow-date-field__placeholder"
            }
          >
            {hasValue ? displayValue : t("settingsWaste.selectDate")}
          </span>
        </button>
        {hasValue ? (
          <button
            type="button"
            className="waste-flow-date-field__clear"
            onClick={handleClear}
            aria-label={t("addressLocation.clearSearchAria")}
          >
            <i className="fas fa-times" aria-hidden />
          </button>
        ) : null}
        <input
          ref={dateInputRef}
          id={id}
          type="date"
          className="waste-flow-date-field__native"
          value={toInputDateValue(value)}
          onChange={(event) => onChange(event.target.value)}
          required={required}
          tabIndex={-1}
          aria-hidden
        />
      </div>
    </div>
  );
};

export default WasteFlowDateField;
